import { render, staticRenderFns } from "./memberInfoSetting.vue?vue&type=template&id=18728d60&scoped=true&"
import script from "./memberInfoSetting.vue?vue&type=script&lang=js&"
export * from "./memberInfoSetting.vue?vue&type=script&lang=js&"
import style0 from "./memberInfoSetting.vue?vue&type=style&index=0&id=18728d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18728d60",
  null
  
)

component.options.__file = "memberInfoSetting.vue"
export default component.exports